import { useState, useEffect } from 'react';

import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import useUserStore from '@lcsc-ui/store/user';
import ecpCurl from '@lcsc-ui/utils/ecpCurl';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import OpApi from '@/apis/op';
import StaticdataApi from '@/apis/staticdata';
import wwwApi from '@/apis/www';

export default function Index({ resourceData, websiteSectionList, catalogList, headerAd }) {
  const metadata = {
    title: '立创商城手机APP_立创商城Android/iOS版APP_立创商城手机客户端下载 - 立创商城',
    description:
      '立创商城SZLCSC.COM一站式电子元器件采购自营商城，拥有13万+平米智能化仓储，海量现货，正品保证，支持一键BOM配单，最快4小时发货，为用户提供电子元器件线上采购服务。嘉立创集团提供“EDA软件/PCB CAM软件、PCB智造、元器件商城、 激光钢网/治具 、SMT贴片”为一体的电子全产业链服务，助力全球硬件创新。',
    additionalMetaTags: [
      {
        name: 'keywords',
        content: '立创商城Android APP,立创商城iOS APP,立创商城手机客户端,立创商城APP下载',
      },
    ],
  };
  const [logined, setLogined] = useState(false);
  const { updateUserInfo } = useUserStore(); // 监听路由
  const [isOldCus, setIsOldCus] = useState(false); // 是否为老用户
  useEffect(() => {
    autoRefreshLoginInfo();
    setIsOldCus(resourceData?.commonConfigVO?.existSendOrder || false);
  }, []);
  const autoRefreshLoginInfo = (data) => {
    updateUserInfo(data);
    setLogined(true);
    window.isLogin = true;
  };
  return (
    <>
      <NextSeo {...metadata}></NextSeo>
      <Head>
        <link rel="canonical" href={resourceData?.projectConfigVO.lcscWwwUrl + '/app.html'} />
      </Head>
      <BaseLayout
        resourceData={resourceData}
        websiteSectionList={websiteSectionList}
        catalogList={catalogList}
        headerAd={headerAd}
        isLgScreen={false}
        notIndexHeaderAdapter
        onlySScreen
        logined={logined}
        isNeedTopAd={true}
        isShowBottomAd={true}
      >
        <div className="w-full h-full bg-[#F6F8FA]" data-spm="app">
          <section className="w-[100%] m-[0px_auto_60px] h-[726px] bg-[url(https://static.szlcsc.com/ecp/assets/web/page/www/app/images/appDownLoad03_3_02.jpg)] bg-no-repeat bg-center relative">
            <a
              target="_blank"
              rel="nofollow"
              data-spm="az"
              href={resourceData?.projectConfigVO.lcscWwwUrl + '/go/android'}
              className="hover:text-[#fff] flex items-center justify-center gap-2 absolute top-[185px] left-[50%] box-border w-[246px] h-[58px] rounded-[29px] text-[20px] text-[#fff] bg-[#ff7800]"
            >
              <img
                src="https://static.szlcsc.com/ecp/assets/web/page/www/app/images/appDownLoad02.png"
                alt="立创商城app Android版下载"
                className="w-[29px] h-[33px]"
              />
              <span className="shrink-0">Android版下载</span>
              <span className="w-[100%] text-center absolute left-0 top-[60px] text-[14px] text-[#ccc]">
                直接下载到电脑
              </span>
            </a>
            <a
              target="_blank"
              rel="nofollow"
              data-spm="ios"
              className="hover:text-[#fff] flex items-center justify-center absolute top-[185px] left-[50%] box-border w-[246px] h-[58px] rounded-[29px] text-[20px] text-[#fff] ml-[260px] bg-transparent border-[3px] border-[#fff] border-solid gap-2"
              href={resourceData?.projectConfigVO.lcscWwwUrl + '/go/ios'}
            >
              <img
                src="https://static.szlcsc.com/ecp/assets/web/page/www/app/images/appDownLoad01.png"
                alt="立创商城app ios版下载"
                className="w-[29px] h-[33px]"
              />
              <span>ios版下载</span>
              <span className="w-[100%] text-center absolute left-0 top-[60px] text-[14px] text-[#ccc]">
                前往appstore下载
              </span>
            </a>
            <div className="w-[100%] absolute bottom-0 left-0 h-[88px] bg-[#000]/70 flex items-center">
              <ul className="z-[1] m-[0_auto] max-w-[1200px] h-[88px] text-[#fff] flex items-center">
                <li className="pl-[8px] border-l-[2px] border-solid border-[#fff] leading-[1]">
                  <p className="text-[22px] font-bold">商品选购</p>
                  <p className="mt-[10px] text-[14px]">明码实价，海量现货一站式购齐！</p>
                </li>
                <li className="pl-[8px] border-l-[2px] border-solid border-[#fff] leading-[1]">
                  <p className="text-[22px] font-bold">便捷支付</p>
                  <p className="mt-[10px] text-[14px]">支持微信/支付宝/预付余额支付等</p>
                </li>
                <li className="pl-[8px] border-l-[2px] border-solid border-[#fff] leading-[1]">
                  <p className="text-[22px] font-bold">闪电发货</p>
                  <p className="mt-[10px] text-[14px]">正品现货库存，最快4小时闪电发货！</p>
                </li>
                <li className="pl-[8px] border-l-[2px] border-solid border-[#fff] leading-[1]">
                  <p className="text-[22px] font-bold">进度跟踪</p>
                  <p className="mt-[10px] text-[14px]">随时随地了解您的订单处理进度</p>
                </li>
              </ul>
            </div>
          </section>
        </div>
        <Toolbar isOldCus={isOldCus}></Toolbar>
      </BaseLayout>
    </>
  );
}

export async function getServerSideProps(context) {
  const { req } = context;
  const [resourceData, catalogList, websiteSectionList, headerAd] = await Promise.all([
    ecpCurl(StaticdataApi.resourceList, { headers: req.headers }),
    ecpCurl(StaticdataApi.catalogList, { headers: req.headers }),
    ecpCurl(OpApi.websiteSection, { headers: req.headers }),
    ecpCurl(OpApi.advertisingHeader),
    ecpCurl(wwwApi.links),
  ]);
  return {
    props: {
      resourceData,
      websiteSectionList,
      catalogList,
      headerAd,
    },
  };
}
